import React from 'react';
import { TableRow } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { IExpenseRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/expenses/types.ts';
import { FINANCIAL_CONDITION_FIELD_LABELS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/constants.ts';
import {
  normalizeBalanceLine,
  normalizeDecimalValue,
  normalizePercentageValue,
  validateBalanceLine,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

export const ExpenseRow: React.FC<IExpenseRowProps> = ({
  name,
  index,
  canRemove,
  disabled,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.reportLine`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.reportLine}
        placeholder="р.1550"
        normalizeOnBlur={normalizeBalanceLine}
        rules={{ validate: validateBalanceLine }}
        inputProps={{ inputMode: 'numeric', maxLength: 6 }}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.reportLineField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.component`}
        label="Складова витрат"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.amount`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.amountThousands}
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`${name}.${index}.sharePercent`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.sharePercent}
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizePercentageValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити витрату ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
